var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edit-user"},[_c('Breadcrumbs',{attrs:{"items":_vm.items}}),_c('v-container',{attrs:{"fluid":""}},[_c('UserForm',{attrs:{"user":_vm.user,"specialities":_vm.specialities,"edit":true}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }